// eslint-disable-next-line
import {
  // UserLayout,
  // BasicLayout,
  // RouteView,
  // BlankLayout,
  // PageView
} from '@/layouts'

// import { shixun, wode, linggan, jiaocai, gongju, shixunActive, wodeActive, lingganActive, jiaocaiActive, gongjuActive } from '@/core/icons'
// import { shixun, wode, linggan, gongju, shixunActive, wodeActive, lingganActive, gongjuActive } from '@/core/icons'

export const asyncRouterMap = [{
  path: '*',
  redirect: '/404',
  hidden: true
}]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [{
    path: '/',
    // component: BasicLayout,
    // redirect: '/login',
  }, {
    path: '/guide/:stuId/:token/:testId/:eid/:domain/:version',
    component: () => import('@/views/guide/Guide'),
    name: 'guide'
  }, {
    path: '/viewExam/:stuId/:token/:testId/:eid/:domain/:version',
    component: () => import('@/views/answer/answer'),
    name: 'answer'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/user/Login'),
    meta: {
      title: '登录'
    },
  }, {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index/Index'),
    meta: {
      title: '首页'
    },
  }, {
    path: '*',
    redirect: '/404',
    hidden: true
  }, {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }
]
